import { useEffect, useRef } from "react";
import { useWindows } from "../../../contexts/windows";

const useMinMaxRef = (id: string): React.MutableRefObject<boolean> => {
  const { windows } = useWindows();
  const { maximized = false, minimized = false } = windows[id] || {};
  const blockAutoPositionRef = useRef(false);

  useEffect(() => {
    blockAutoPositionRef.current = Boolean(maximized || minimized);
  }, [maximized, minimized]);

  return blockAutoPositionRef;
};

export default useMinMaxRef;
